import { render, staticRenderFns } from "./salesrevorderfrm.vue?vue&type=template&id=1b32dd1a"
import script from "./salesrevorderfrm.vue?vue&type=script&lang=js"
export * from "./salesrevorderfrm.vue?vue&type=script&lang=js"
import style0 from "./salesrevorderfrm.vue?vue&type=style&index=0&id=1b32dd1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports